import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { Theme } from '@/utils/constants';

import { AdditionalContentProps } from './AdditionalContent.interface';
import useStyles from './AdditionalContent.styles';
import { MuiTypography } from '@/features/shared/material-ui';
import { CaptureClicksRichText } from '@/features/shared';

const HorizontalDivider = ({ classes }: any) => {
  return <div className={classes} />;
};

const AdditionalContent = ({
  theme = Theme.light,
  content,
}: PropsWithChildren<AdditionalContentProps>) => {
  const classes = useStyles({});
  const rootClassName = clsx(classes.root, `${theme}-theme`);

  if (!content || content.length === 0) return null;

  return (
    <div className={rootClassName}>
      <HorizontalDivider classes={classes.divider} />
      {content.map(({ heading, detailContent }, id) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={id} className={classes.content}>
          {heading && (
            <MuiTypography variant="overline" component="h6" className={classes.heading}>
              {heading}
            </MuiTypography>
          )}
          {detailContent && (
            <CaptureClicksRichText
              theme={theme}
              className={classes.description}
              content={detailContent}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default memo(AdditionalContent);
